import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Row,
  CardTitle,
  CardText,
  CardHeader,
} from "reactstrap";
import { addChequeBounceCharges, getDayBookData } from "../../util/APIUtils";
import { LoadingOverlay } from "../../util/Helpers";
import DayBookBody from "./DayBookBody";
import { ButtonStyles } from "../../constants/ButtonStyles";

export default function DayBook() {
  const [values, setValues] = useState({
    frmDate: new Date().toISOString().substring(0, 10),
    toDate: new Date().toISOString().substring(0, 10),
  });
  const [trans, setTrans] = useState({});
  const [block, setBlock] = useState(false);
  const [open, setOpen] = useState(false);
  const [contextMenuPosition, setContextMenuPosition] = useState({ x: 0, y: 0 });
  const [currentRow, setCurrentRow] = useState({});

  useEffect(() => {
    loadReqData();
  }, []);

  const toggle = () => setOpen(!open);

  const selectedOption = (option) => {
    if (option === 1) {
      addChequePenality();
    }
  };

  const addChequePenality = () => {
    setBlock(true);
    addChequeBounceCharges(values).then(() => {
      swal({ text: "Added Cheque Bounce charges successfully" });
      setBlock(false);
    });
  };

  const handleRightClick = (e, row) => {
    e.preventDefault();
    setContextMenuPosition({ x: e.clientX, y: e.clientY });
    setOpen(true);
    setCurrentRow(row);
  };

  const loadReqData = () => {
    setBlock(true);
    getDayBookData(values).then((response) => {
      setTrans(response);
      setBlock(false);
    });
  };

  const onChangeNotesMap = ({ target: { name, value } }) => {
    setValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const updateMap = () => {
    if (Object.keys(values).length !== 2) return;
    setBlock(true);
    getDayBookData(values).then((response) => {
      setTrans(response);
      setBlock(false);
    });
  };

  const clearAll = () => {
    setValues({
      frmDate: new Date().toISOString().substring(0, 10),
      toDate: new Date().toISOString().substring(0, 10),
    });
  };

  return (
    <div>
      {block && <LoadingOverlay />}
      <Card style={{
        borderRadius: "15px",
        boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
        border: "none",
        overflow: "hidden"
      }}>
        <CardHeader style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          padding: "20px 25px",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: "none"
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <i className="fa fa-book" style={{ fontSize: "24px", color: "#fff" }}></i>
            <strong style={{ fontSize: '1.2rem', color: "#fff" }}>Day Book</strong>
          </div>
        </CardHeader>
        <CardBody style={{ padding: "25px" }}>
          <Row className="mb-3" style={{ alignItems: "center" }}>
            <Col sm="3">
              <Input
                bsSize="sm"
                type="date"
                name="frmDate"
                id="frmDate"
                onChange={onChangeNotesMap}
                value={values.frmDate}
                style={{ borderRadius: "8px", border: "1px solid #e0e0e0", padding: "8px 12px" }}
              />
            </Col>
            <Col sm="3">
              <Input
                bsSize="sm"
                type="date"
                name="toDate"
                id="toDate"
                onChange={onChangeNotesMap}
                value={values.toDate}
                style={{ borderRadius: "8px", border: "1px solid #e0e0e0", padding: "8px 12px" }}
              />
            </Col>
            <Col sm="3">
              <Button
                style={{ ...ButtonStyles.primarySm, marginRight: "10px" }}
                onClick={updateMap}
              >
                <i className="fa fa-search" style={{ marginRight: "5px" }} />Go
              </Button>
              <Button style={ButtonStyles.secondarySm} onClick={clearAll}>
                <i className="fa fa-times" style={{ marginRight: "5px" }} />Clear
              </Button>
            </Col>
          </Row>
          <Row style={{ marginBottom: "25px" }}>
            <Col sm="4">
              <Card style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                borderRadius: "12px",
                border: "none",
                padding: "20px",
                color: "#fff"
              }}>
                <div style={{ fontSize: "14px", opacity: "0.9" }}>Total Payment In</div>
                <div style={{ fontSize: "28px", fontWeight: "700" }}>{trans.totalPaymentIn || 0}</div>
              </Card>
            </Col>
            <Col sm="4">
              <Card style={{
                background: "linear-gradient(135deg, #f7971e 0%, #ffd200 100%)",
                borderRadius: "12px",
                border: "none",
                padding: "20px",
                color: "#fff"
              }}>
                <div style={{ fontSize: "14px", opacity: "0.9" }}>Total Payment Out</div>
                <div style={{ fontSize: "28px", fontWeight: "700" }}>{trans.totalPaymentOut || 0}</div>
              </Card>
            </Col>
            <Col sm="4">
              <Card style={{
                background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                borderRadius: "12px",
                border: "none",
                padding: "20px",
                color: "#fff"
              }}>
                <div style={{ fontSize: "14px", opacity: "0.9" }}>Total Difference</div>
                <div style={{ fontSize: "28px", fontWeight: "700" }}>{trans.totalPaymentIn - trans.totalPaymentOut || 0}</div>
              </Card>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <div className="animated fadeIn" style={{ marginTop: "20px" }}>
        <DayBookBody
          data={trans.dayBook}
          open={open}
          toggle={toggle}
          selectedOption={selectedOption}
          handleRightClick={handleRightClick}
          contextMenuPosition={contextMenuPosition}
          currentRow={currentRow}
        />
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/CustomComponents/DayBook.js